import { css } from '@emotion/core';
import colors from '../../_shared/colors';

const highlight = colors && colors.highlight ? colors.highlight : '#1890ff';

const styles = {
  wrapper: css`
    padding: 16px 24px 48px;
  `,
  titleBlock: css`
    text-align: center;
    margin: 4px auto 12px;
    width: 100%;
  `,
  title: css`
    font-size: 22px;
    font-weight: 600;
    color: #222;
    margin: 0;
    text-align: center;
  `,
  subtitle: css`
    font-size: 13px;
    color: #777;
    margin: 4px auto 0;
    text-align: center;
    max-width: 760px;
  `,
  card: css`
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 16px;
    margin: 16px 0;
  `,
  cardHead: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  `,
  cardTitle: css`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
  `,
  cardHint: css`
    font-size: 12px;
    color: #888;
    margin: 4px 0 0;
    max-width: 640px;
  `,
  presetGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 10px 20px;
  `,
  presetRow: css`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
  `,
  presetLabel: css`
    flex: 1;
    min-width: 0;
  `,
  presetName: css`
    font-size: 13px;
    color: #333;
    display: block;
  `,
  presetDates: css`
    font-size: 11px;
    color: #999;
    display: block;
  `,
  weekdayRow: css`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  `,
  weekdayOn: css`
    background: ${highlight} !important;
    border-color: ${highlight} !important;
    color: #fff !important;
  `,
  saveRow: css`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 14px;
  `,
  dirty: css`
    font-size: 12px;
    color: #d48806;
    align-self: center;
    margin-right: auto;
  `,
  modalField: css`
    margin-bottom: 14px;
  `,
  fieldLabel: css`
    font-size: 12px;
    color: #555;
    margin-bottom: 4px;
    display: block;
  `,
  fieldHint: css`
    font-size: 11px;
    color: #999;
    margin-top: 4px;
  `,
  modalError: css`
    font-size: 12px;
    color: #cf1322;
    margin-top: 8px;
  `,
  kindPill: css`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background: #f0f5ff;
    color: #2f54eb;
    border: 1px solid #d6e4ff;
    font-size: 12px;
    text-align: center;
  `,
  previewList: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 6px 20px;
    max-height: 260px;
    overflow-y: auto;
  `,
  previewItem: css`
    font-size: 12px;
    color: #444;
    border-bottom: 1px dashed #f0f0f0;
    padding: 3px 0;
  `,
  previewWhy: css`
    color: #999;
  `,
  empty: css`
    font-size: 13px;
    color: #999;
    padding: 8px 0;
  `,
  iconBtn: css`
    cursor: pointer;
    color: #555;
    margin-right: 12px;
    &:hover { color: ${highlight}; }
  `,
  iconBtnDanger: css`
    cursor: pointer;
    color: #cf1322;
    &:hover { color: #a8071a; }
  `,
  footNote: css`
    font-size: 11px;
    color: #aaa;
    text-align: center;
    margin-top: 8px;
  `,
};

export default styles;
